/**
 * Supported ISO 639 language codes for order management.
 */
export enum SupportedLanguages {
    AR = 'ar', // Arabic
    CS = 'cs', // Czech
    DA = 'da', // Danish
    DE = 'de', // German
    EL = 'el', // Greek
    EN = 'en', // English (US)
    EN_GB = 'en-gb', // English (United Kingdom)
    ES = 'es', // Spanish
    ET = 'et', // Estonian
    FI = 'fi', // Finnish
    FR = 'fr', // French
    FR_BE = 'fr-be', // French (Belgium)
    IT = 'it', // Italian
    LT = 'lt', // Lithuanian
    LV = 'lv', // Latvian
    NL = 'nl', // Dutch (Netherlands)
    NL_BE = 'nl-be', // Dutch (Belgium)
    NO = 'no', // Norwegian
    PL = 'pl', // Polish
    PT = 'pt', // Portuguese
    SV = 'sv', // Swedish
    TR = 'tr', // Turkish
    LB = 'lb' // Luxembourgish
}
